import { useTranslation } from "react-i18next";
import {
  FiDroplet,
  FiTool,
  FiSun,
  FiMapPin,
  FiHome,
  FiUsers,
  FiShield,
  FiTruck
} from "react-icons/fi";
import { motion } from "framer-motion";

const features = [
  {
    icon: <FiDroplet size={28} className="text-primary" />,
    titleKey: "features.filtration.title",
    descKey: "features.filtration.description"
  },
  {
    icon: <FiTool size={28} className="text-primary" />,
    titleKey: "features.construction.title",
    descKey: "features.construction.description"
  },
  {
    icon: <FiSun size={28} className="text-primary" />,
    titleKey: "features.heating.title",
    descKey: "features.heating.description"
  },
  {
    icon: <FiMapPin size={28} className="text-primary" />,
    titleKey: "features.consultation.title",
    descKey: "features.consultation.description"
  },
  {
    icon: <FiHome size={28} className="text-primary" />,
    titleKey: "features.maintenance.title",
    descKey: "features.maintenance.description"
  },
  {
    icon: <FiUsers size={28} className="text-primary" />,
    titleKey: "features.design.title",
    descKey: "features.design.description"
  },
  {
    icon: <FiShield size={28} className="text-primary" />,
    titleKey: "features.safety.title",
    descKey: "features.safety.description"
  },
  {
    icon: <FiTruck size={28} className="text-primary" />,
    titleKey: "features.supply.title",
    descKey: "features.supply.description"
  }
];

const FeatureSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <motion.h2
          className="text-3xl font-bold mb-6 text-gray-900"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {t("features.sectionTitle")}
        </motion.h2>
        <motion.p
          className="text-lg text-gray-600 mb-12"
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {t("features.sectionSubtitle")}
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              className="bg-gray-50 rounded-xl shadow hover:shadow-md transition p-6 text-left"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {t(feature.titleKey)}
              </h3>
              <p className="text-sm text-gray-600">
                {t(feature.descKey)}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.div
          className="mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <a
            href="/contact"
            className="inline-block bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primary/90"
          >
            {t("features.cta")}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureSection;
